import React, { useEffect, useState } from "react";
import { stationApi } from "../../../../../api/newApi";
import StationProcess from "../../../../../components/StationProcess";
import "./index.scss";

export default ({ stationId }) => {
  const [previewProcessData, setPreviewProcessData] = useState({});
  let timer = null;

  useEffect(() => {
    if (stationId) {
      getData();
      timer = setInterval(getData, 1000 * 30);
    }
    return () => {
      timer && clearInterval(timer);
    };
  }, [stationId]);

  const getData = async () => {
    // 获取工艺流程
    const res = await stationApi.findFlowByStationId(stationId);
    if (res.status == "0") {
      const params = {
        stationId,
        name: `工艺流程`,
        ...res.data,
      };
      setPreviewProcessData(params);
    } else {
      setPreviewProcessData({
        stationId,
        name: `工艺流程`,
        canvasWidth: 0,
        canvasHeight: 0,
        iotGatewayNum: 0,
        processFlowUnitDTOList: [],
        processFlowDeviceDiyDTOList: [],
        canvasBg: "",
      });
    }
  };

  return (
    <div className="factory-shebei">
      <StationProcess previewProcessData={previewProcessData} dataShow={true} />
    </div>
  );
};
